import sumaBlanco from '../assets/sumaBlanco.png';

export const ButtonAdmin = ({ text, isOpen, onClick, modalId, className, havePlus = true }) => {

    const modalProps = modalId
        ? {
            "data-bs-toggle": "modal",
            "data-bs-target": `#${modalId}`
        }
        : {};

    return (
        <button
            className={`btn colorPrincipal text-white bold-botones rounded-boton d-inline-block btn-cuadrado btn-blur-mobile ${isOpen ? 'bg-color-cerrar' : ''} ${className}`}
            type="button"
            onClick={onClick}
            {...modalProps}
        >
            {!isOpen ? (
                <div className='centrarContainer'>
                    {text}
                    {havePlus && <img className='ms-2' src={sumaBlanco} alt="" />}
                </div>
            ) : (
                <>
                    Cerrar
                    <img className='ms-2 rotate-45' src={sumaBlanco} alt="" />
                </>
            )}
        </button>
    );
};